import { useEffect, useRef, useState } from "react";
import {
  ICardListResponse,
  ICardResponse,
  IListCardResponseModel,
  IListResponseModel,
  TOptionalType,
} from "../../../core/models";
import CardNews from "../../Cards/CardNews/CardNews";
import Title from "../../Title/Title";
import "./listcard.scss";
import { getCardListResponse } from "../../../core/api.service";
import CardMultimedya from "../../Cards/CardMultimedya/CardMultimedya";
import CardPodcast from "../../Cards/CardPodcast/CardPodcast";
import CardDocumentList from "../../Cards/CardDocumentList/CardDocumentList";
import SelectBox, { Option } from "../../SelectBox/SelectBox";
import Pagination from "../../Pagination/Pahination";
import { groupByYear, IYearMonthModel } from "../../../core/year.helper";
import Loading from "../../Loading/Loading";

export interface IListCardProps {
  props: IListCardResponseModel;
}

const ListCard = ({ props }: IListCardProps) => {
  const [list, setList] = useState<TOptionalType<ICardListResponse>>();
  const [monthOptions, setMonthOptions] = useState<TOptionalType<Option[]>>([]);
  const [yearMonths, setYearMonths] =
    useState<TOptionalType<IYearMonthModel[] | undefined>>(undefined);
  const [selectedYearAndMonth, setSelectedYearAndMonth] = useState<
    { year: string | undefined; month: string | undefined } | undefined
  >(undefined);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(0);
  const [resetTrigger, setResetTrigger] = useState(false);

  const containerRef = useRef<HTMLUListElement>(null);

  const handleYearChange = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (containerRef.current) {
      const buttons = containerRef.current.querySelectorAll(
        ".section-document__date-button"
      );
      buttons.forEach((element) => {
        element.classList.remove("active");
      });
    }
    event.currentTarget.classList.add("active");

    setMonthOptions(
      yearMonths?.find(
        (item: IYearMonthModel) =>
          item.year.toString() === event.currentTarget.innerHTML
      )?.months
    );
    setSelectedYearAndMonth({
      year: event.currentTarget.innerHTML,
      month: "0",
    });
    setCurrentPage(1);
    setResetTrigger((prev) => !prev);
  };

  const handleMonthChange = (month: string) => {
    setSelectedYearAndMonth({
      month: month,
      year: selectedYearAndMonth?.year,
    });
    setCurrentPage(1);
  };

  const onPageChange = (page: number) => {
    setCurrentPage(page + 1);
  };

  useEffect(() => {
    getCardListResponse(
      props.type_value,
      props.parent_page?.id ?? "0",
      currentPage,
      selectedYearAndMonth?.year ?? "0",
      selectedYearAndMonth?.month ?? "0",
      props.category_type
    ).then((response: IListResponseModel) => {
      if (response.data.years?.length) {
        const groupValue = groupByYear(response.data.years);
        setYearMonths(groupValue);

        setMonthOptions(
          groupValue?.find(
            (item: IYearMonthModel) =>
              item.year.toString() === selectedYearAndMonth?.year
          )?.months
        );

        if (
          (selectedYearAndMonth?.year && selectedYearAndMonth?.year !== "0") ||
          (selectedYearAndMonth?.month && selectedYearAndMonth?.month !== "0")
        ) {
          setList(response.data);
          setPageSize(response.totalPage);
        }

        if (!selectedYearAndMonth?.year || selectedYearAndMonth.year === "0") {
          setSelectedYearAndMonth({
            year: groupValue?.at(0)?.year.toString(),
            month: groupValue?.at(0)?.months.at(0)?.value,
          });
        }
      }
    });
  }, [
    props.type_value,
    props.parent_page?.id,
    currentPage,
    selectedYearAndMonth,
    props.category_type,
  ]);

  useEffect(() => {
    if (
      selectedYearAndMonth?.year &&
      window &&
      (window as any)["ReactNativeWebView"]
    ) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Detay Alt Menü",
          eventSegment: {
            tarih: selectedYearAndMonth?.year,
            baslik: props.title,
          },
          actionType: "event",
        })
      );
    }
  }, [selectedYearAndMonth?.year]);

  return (
    <>
      <Title>{props.title}</Title>
      <section
        className={
          "card-list " +
          (list?.documentList && list.documentList.length ? "document" : "")
        }
      >
        <p className="card-list__description">{props.spot}</p>

        {!list ? (
          <Loading isFull={true} />
        ) : (
          <>
            {list?.documentList != null && (
              <>
                <ul className="section-document__date" ref={containerRef}>
                  {yearMonths?.map((item: IYearMonthModel, index: number) => {
                    return (
                      <li className="section-document__date-item" key={index}>
                        <button
                          className={
                            "section-document__date-button " +
                            (selectedYearAndMonth?.year === item.year.toString()
                              ? "active"
                              : "")
                          }
                          onClick={handleYearChange}
                        >
                          {item.year}
                        </button>
                      </li>
                    );
                  })}
                </ul>
                {monthOptions?.length && (
                  <SelectBox
                    options={monthOptions ?? []}
                    resetTrigger={resetTrigger}
                    selectedMonth={selectedYearAndMonth?.month}
                    onChange={handleMonthChange}
                  />
                )}

                {list.documentList.length ? (
                  <ul className="section-document__cards">
                    {list?.documentList?.map(
                      (card: ICardResponse, index: number) => {
                        return (
                          <li key={index}>
                            <CardDocumentList
                              title={props.title}
                              props={card}
                              index={index}
                            />
                          </li>
                        );
                      }
                    )}
                  </ul>
                ) : (
                  <span className="empty-result-title">
                    Sonuç bulunamadı...
                  </span>
                )}
              </>
            )}

            {list?.cmsdocumentList != null && (
              <>
                <ul className="section-document__date" ref={containerRef}>
                  {yearMonths?.map((item: IYearMonthModel, index: number) => {
                    return (
                      <li className="section-document__date-item" key={index}>
                        <button
                          className={
                            "section-document__date-button " +
                            (selectedYearAndMonth?.year === item.year.toString()
                              ? "active"
                              : "")
                          }
                          onClick={handleYearChange}
                        >
                          {item.year}
                        </button>
                      </li>
                    );
                  })}
                </ul>
                {monthOptions && (
                  <SelectBox
                    options={monthOptions ?? []}
                    resetTrigger={resetTrigger}
                    selectedMonth={selectedYearAndMonth?.month}
                    onChange={handleMonthChange}
                  />
                )}
                {list.cmsdocumentList.length ? (
                  <ul className="section-document__cards">
                    {list?.cmsdocumentList?.map(
                      (card: ICardResponse, index: number) => {
                        return (
                          <li key={index}>
                            <CardDocumentList
                              title={props.title}
                              props={card}
                              index={index}
                            />
                          </li>
                        );
                      }
                    )}
                  </ul>
                ) : (
                  <span className="empty-result-title">
                    Sonuç bulunamadı...
                  </span>
                )}
              </>
            )}

            {(list?.newsList?.length ||
              list?.multimediaList?.length ||
              list?.podcastList?.length) && (
              <div
                className={
                  "row" + (list?.documentList?.length ? " list-multi" : "")
                }
              >
                {list?.newsList?.map((card: ICardResponse) => {
                  return (
                    <div className="col-6" key={card.id}>
                      <CardNews props={card} title={props.title}></CardNews>
                    </div>
                  );
                })}
                {list?.multimediaList?.map((card: ICardResponse) => {
                  return (
                    <div className="col-6" key={card.id}>
                      <CardMultimedya props={card}></CardMultimedya>
                    </div>
                  );
                })}
                {list?.podcastList?.map((card: ICardResponse) => {
                  return (
                    <div className="col-6" key={card.id}>
                      <CardPodcast props={card}></CardPodcast>
                    </div>
                  );
                })}
              </div>
            )}

            {pageSize > 1 && (
              <Pagination pageCount={pageSize} onPageChange={onPageChange} />
            )}
          </>
        )}
      </section>
    </>
  );
};

export default ListCard;
